var config = process.server ? require('config') : {
  get: () => ''
};
export default {
  cdn: config.get('cdn'),
  env: config.get('env'),
  web: config.get('web'),
  recaptcha: config.get('recaptcha'),
  catalog: config.get('proxy.catalog'),
  prismic: config.get('prismic'),
  graphqlExternal: config.get('graphql.external'),
  graphqlInternal: config.get('graphql.internal'),
  graphqlShopInternal: config.get('graphql.shop.internal'),
  graphqlShopExternal: config.get('graphql.shop.external'),
  tracking: {
    container: config.get('tracking.container'),
    id: config.get('tracking.id'),
    checkout: {
      container: config.get('tracking.checkout.container'),
      id: config.get('tracking.checkout.id')
    }
  },
  oauth: {
    clientId: config.get('oauth.clientId'),
    redirectUri: config.get('oauth.redirectUri')
  },
  dalenys: config.get('dalenys'),
  gmaps: config.get('gmaps'),
  mercureDocument: config.get('mercureDocument'),
  gameId: config.get('gameId'),
  algolia: {
    applicationId: config.get('algolia.applicationId'),
    apiKey: config.get('algolia.apiKey'),
    indexName: config.get('algolia.indexName'),
    categoryIndexName: config.get('algolia.categoryIndexName'),
    suggestionIndexSuffix: config.get('algolia.suggestionIndexSuffix')
  },
  mdmToggleOpenFacets: config.get('mdmToggleOpenFacets'),
  appShopUrl: config.get('appShopUrl')
};